import { motion, useReducedMotion } from "framer-motion";
import { CONTACT } from "@/lib/site";

const MESSAGE = "Hello FAD, I'd like to learn more about investing in Dubai real estate.";

export function WhatsAppButton() {
  const reduce = useReducedMotion();
  const href = `https://wa.me/${CONTACT.whatsapp.replace("+", "")}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with FAD on WhatsApp"
      initial={reduce ? false : { opacity: 0, scale: 0.8, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-40 flex items-center gap-3 rounded-full glass pl-3 pr-3 sm:pr-5 py-3 hover:-translate-y-0.5 transition-transform duration-200"
      data-testid="whatsapp-floating-button"
    >
      <span className="h-10 w-10 rounded-full bg-[#25D366] grid place-items-center shadow-md">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="#fff" aria-hidden="true">
          <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.93.95-3.48-.22-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.2 4.24-9.44 9.45-9.44a9.4 9.4 0 0 1 6.68 2.77 9.38 9.38 0 0 1 2.76 6.68c0 5.21-4.24 9.44-9.45 9.44zm8.04-17.48A11.3 11.3 0 0 0 12.05.7C5.78.7.68 5.8.68 12.06c0 2 .52 3.96 1.52 5.68L.58 23.7l6.1-1.6a11.33 11.33 0 0 0 5.37 1.37h.01c6.26 0 11.36-5.1 11.36-11.37 0-3.03-1.18-5.89-3.33-8.03z" />
        </svg>
      </span>
      <span className="hidden sm:block text-sm font-semibold text-[#0B1F3A]">Chat on WhatsApp</span>
    </motion.a>
  );
}
